import styles from "../buttons/Button.module.css";

const Buttons = ({
  text,
  onClick,
  type = "button",
  disabled = false,
  icon,
  variant = "primary", // default to primary
}) => {
const disabledStyles = {
  opacity: 0.5,
  cursor: "no-drop",
};
  return (
    <div className={styles.buttonPostion}>
      <button
        className={`${styles.button} ${styles[variant]}`} // apply variant class
        onClick={onClick}
        type={type}
        disabled={disabled}
        style={disabled ? disabledStyles : {}}
      >
        {icon && <span className="icon">{icon}</span>}
        {text}
      </button>
    </div>
  );
};

export default Buttons;
